@if (show) {
  <div
    class="fixed z-50 top-4 -left-10 -rotate-45 pointer-events-none bg-lPrimary dark:bg-lPrimaryLight opacity-90 text-lWhite text-center p-2 min-w-40"
  >
    {{ name }}
  </div>
}
